const vibrate = (pattern: number | number[]) => {
  const navigator = window.navigator;

  navigator.vibrate =
    navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;

  if (navigator.vibrate) {
    navigator.vibrate(pattern);
  }
};

export default vibrate;
